import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityOverview = ({ timeRange }) => {
  const metrics = [
    {
      title: 'Suspicious Logins',
      value: '12',
      change: '-15.2%',
      changeType: 'positive',
      icon: 'ShieldAlert',
      color: 'bg-error',
      status: 'warning',
      subMetrics: [
        { label: 'Failed Attempts', value: '28' },
        { label: 'Blocked IPs', value: '5' }
      ]
    },
    {
      title: 'API Health',
      value: '99.8%',
      change: '+0.2%',
      changeType: 'positive',
      icon: 'Zap',
      color: 'bg-success',
      status: 'healthy',
      subMetrics: [
        { label: 'Requests/min', value: '1,247' },
        { label: 'Errors', value: '3' }
      ]
    },
    {
      title: 'System Uptime',
      value: '99.95%',
      change: 'Stable',
      changeType: 'neutral',
      icon: 'Activity',
      color: 'bg-primary',
      status: 'healthy',
      subMetrics: [
        { label: 'Avg Response', value: '145ms' },
        { label: 'Downtime', value: '0min' }
      ]
    },
    {
      title: 'Config Changes',
      value: '7',
      change: '+2',
      changeType: 'neutral',
      icon: 'Settings',
      color: 'bg-warning',
      status: 'attention',
      subMetrics: [
        { label: 'Authorized', value: '7' },
        { label: 'Unauthorized', value: '0' }
      ]
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'healthy': return 'text-success';
      case 'warning': return 'text-warning';
      case 'attention': return 'text-accent';
      default: return 'text-muted-foreground';
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {metrics?.map((metric, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg ${metric?.color} flex items-center justify-center`}>
              <Icon name={metric?.icon} size={24} color="white" />
            </div>
            <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium
              ${metric?.status === 'healthy' ? 'bg-success/10 text-success' :
                metric?.status === 'warning' ? 'bg-warning/10 text-warning' :
                metric?.status === 'attention'? 'bg-accent/10 text-accent' : 'bg-muted/50 text-muted-foreground'
              }`}>
              {metric?.status?.toUpperCase()}
            </span>
          </div>
          <h3 className="text-sm font-medium text-muted-foreground mb-1">
            {metric?.title}
          </h3>
          <div className="flex items-baseline space-x-2 mb-4">
            <p className="text-2xl font-bold text-foreground">
              {metric?.value}
            </p>
            <span className={`text-sm font-medium ${
              metric?.changeType === 'positive' ? 'text-success' :
              metric?.changeType === 'negative'? 'text-error' : 'text-muted-foreground'
            }`}>
              {metric?.change}
            </span>
          </div>
          <div className="space-y-2 pt-4 border-t border-border">
            {metric?.subMetrics?.map((sub, idx) => (
              <div key={idx} className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">{sub?.label}</span>
                <span className="font-medium text-foreground">{sub?.value}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SecurityOverview;